import { Platform, StyleSheet, ViewStyle } from 'react-native';

import { Fonts } from 'assets/fonts';

import { ContentType } from 'services/data-manager/types';

import { COLOR, lightGrey } from 'utils/colors';
import { isTablet, isWeb, widthPercentageToDP } from 'utils/responsiveness';

const styles = StyleSheet.create({
    list: {
        marginHorizontal: Platform.select({
            web: 0,
            default: widthPercentageToDP(16, 0),
        }),
    },
    titleContainer: {
        alignSelf: 'flex-start',
        marginLeft: widthPercentageToDP(72),
        marginTop: 24,
        paddingBottom: isWeb ? 0 : 44,
        zIndex: 100,
        flexDirection: 'row',
        alignItems: 'center',
    },
    titleText: {
        fontFamily: Fonts.main.bold,
        fontSize: 20,
        color: COLOR.WHITE,
    },
    numberText: {
        fontFamily: Fonts.main.regular,
        fontSize: 20,
        marginLeft: 8,
        color: 'rgba(238, 238, 238, 0.7)',
    },
    movie: {
        width: widthPercentageToDP(328),
    },
    series: {
        width: widthPercentageToDP(328),
    },
    person: {
        width: widthPercentageToDP(156),
    },
    program: {
        width: widthPercentageToDP(328),
    },
    tv_now_next: {
        width: Platform.select({
            web: widthPercentageToDP(272),
            default: widthPercentageToDP(206),
        }),
    },
    catchup: {
        width: Platform.select({
            web: widthPercentageToDP(272),
            default: widthPercentageToDP(206),
        }),
    },
    channel: {
        width: Platform.select({
            web: widthPercentageToDP(176),
            default: widthPercentageToDP(104, 132),
        }),
    },
    columnWrap: {
        marginHorizontal: Platform.select({
            web: widthPercentageToDP(72, 0),
            default: widthPercentageToDP(0, 44),
        }),
        flexWrap: 'wrap',
        justifyContent: 'space-between',
    },
    listContentContainer: {
        flexGrow: 1,
        paddingBottom: 40,
        paddingTop: isWeb ? 44 : 0,
    },
    listContentContainerNowNext: {
        paddingTop: Platform.select({
            web: 44,
            default: isTablet ? 16 : 14,
        }),
    },
    noContentContainer: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
    },
    noContentText: {
        fontFamily: Fonts.main.regular,
        fontSize: 16,
        lineHeight: 24,
        color: lightGrey(0.7),
        textAlign: 'center',
        marginHorizontal: 16,
    },
    skeletonContainer: {
        marginTop: Platform.select({
            web: 0,
            default: isTablet ? 16 : 14,
        }),
        justifyContent: Platform.select({
            web: 'flex-end',
            default: 'flex-start',
        }),
    },
    skeletonSvgContainer: {
        paddingTop: 60,
    },
});

export const listContainerStyle: Partial<Record<ContentType, ViewStyle>> = {
    [ContentType.NowNext]: styles.listContentContainerNowNext,
};

export const emptyItemStyleByContentType: Partial<
    Record<ContentType, ViewStyle>
> = {
    [ContentType.ChannelItem]: styles.channel,
    [ContentType.NowNext]: styles.tv_now_next,
    [ContentType.Catchup]: styles.catchup,
    [ContentType.VOD]: styles.catchup,
    [ContentType.SearchCatchup]: styles.catchup,
    [ContentType.SearchProgram]: styles.catchup,
    [ContentType.NPVR]: styles.catchup,
    [ContentType.ContinueWatching]: styles.catchup,
};

export default styles;
